import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MountedMaterialViewModel } from 'chronos-core-client';

@Component({
  selector: 'app-consumption-pallet-item',
  templateUrl: './consumption-pallet-item.component.html',
  styleUrls: ['./consumption-pallet-item.component.scss']
})
export class ConsumptionPalletItemComponent {
  @Input() public consumedContainer: MountedMaterialViewModel;
  @Input() public activeOrderRunId: number;
  @Output() public dismountIconClicked = new EventEmitter<MountedMaterialViewModel>();

  public onDismountClick(consumed: MountedMaterialViewModel) {
    if (this.consumedContainer.runId === this.activeOrderRunId) {
      this.dismountIconClicked.emit(consumed);
    }
  }
}
